import { render } from "./ChangeStoragePoolScope.vue?vue&type=template&id=2e8df9e2"
import script from "./ChangeStoragePoolScope.vue?vue&type=script&lang=js"
export * from "./ChangeStoragePoolScope.vue?vue&type=script&lang=js"

import "./ChangeStoragePoolScope.vue?vue&type=style&index=0&id=2e8df9e2&lang=scss"

import exportComponent from "/builds/cloudstack/keycloak-auth/.cloudstack-src/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__